import { Events } from "../types";
import { submitSPEvents } from "./emitSnowplowEvent";
export function emitCart() {
  submitSPEvents([{
    context: Events.CART
  }]);
}